import { httpRequest } from "../../http";
import {Engagement} from "@models/engagement.model.ts";
import {EngagementSerializer} from "@models/serializers/engagementSerializer.ts";

export interface CreateEngagementOpts {
    name?: string;
    adIds?: number[];
    additionalNotes?: string;
}

export class CommandCreateEngagement {

    async run(provider_id: number, client_id: number, type: string, opts: CreateEngagementOpts = {}) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/`;
        const body: Record<string, unknown> = {
            type,
            service_provider: { id: provider_id },
            client: { id: client_id },
        };
        if (opts.name) {
            body.name = opts.name;
        }
        if (opts.adIds && opts.adIds.length > 0) {
            body.ads = opts.adIds.map((id) => ({ id }));
        }
        if (opts.additionalNotes) {
            body.additional_notes = opts.additionalNotes;
        }

        try {
            const response = await httpRequest<any>(url, { method: "POST", body });
            return this.deserialize(response);
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any): Engagement {
        const serializer = new EngagementSerializer();
        return serializer.deserialize(data);
    }
}
